var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.492 1.058a3.58 3.58 0 0 0-4.973.489L6.472 2.8a.893.893 0 1 0 1.37 1.145L8.89 2.692a1.78 1.78 0 0 1 2.545-.189 1.819 1.819 0 0 1 .15 2.509L9.407 7.617l-.02.023a1.778 1.778 0 0 1-2.643.045.893.893 0 0 0-1.307 1.217 3.567 3.567 0 0 0 5.343-.143l2.17-2.598a3.67 3.67 0 0 0 .828-2.695 3.505 3.505 0 0 0-1.287-2.408z",
    fill: "#85B440"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6.066 10.706-.936 1.12a1.819 1.819 0 0 1-2.495.3 1.781 1.781 0 0 1-.267-2.54l2.214-2.65.016-.018a1.774 1.774 0 0 1 2.674-.013.892.892 0 0 0 1.047.216.882.882 0 0 0 .297-.23l.011-.013a.88.88 0 0 0-.015-1.153 3.565 3.565 0 0 0-5.407.074L.998 8.44a3.58 3.58 0 0 0 .403 4.981 3.506 3.506 0 0 0 2.598.838 3.668 3.668 0 0 0 2.505-1.293l.932-1.116a.893.893 0 0 0-1.37-1.145z",
    fill: "#85B440"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.9f1e6d6bba86822ea1526532c9bc3a3f.svg";
export { ForwardRef as ReactComponent };